import utiles from "@/modules/Shared/utiles/utiles";
import store from "@/store";
import axios from "axios";

export default class EstadoService {
    constructor() {
        this.axios = axios.create({
            baseURL: utiles.state.api,
            headers: {
                'content-type': "application/json",
                Accept: "application/json",
                Authorization: "Bearer " + store.state.user.token
            }
        });
        store.watch(
            (state) => state.user,
            (newUser) => {
              this.axios.defaults.headers.Authorization = `Bearer ${newUser.token}`;
            }
          );
    }


    async getAll() {
        const response = await this.axios.get('estado');
        return response.data;
    }

    async createEstado(data) {
        const response = await this.axios.post('estado', data);
        return response.data;
    }

    async updateEstado(data) {
        const response = await this.axios.put('estado', data);
        return response.data;
    }

    async deleteEstado(idestado) {
        const response = await this.axios.delete('estado?idestado=' + idestado)
        return response.data;
    }
}